export default __webpack_public_path__ + "static/media/doctor-3.b94513a2.png";